export interface Membership {
  id: string;
  name: string;
  price: number;
  description: string;
  features: string[];
  popular?: boolean;
  callToAction: string;
  paymentLink?: string;
  productTitle?: string;
  displayOnPricing?: boolean;
}

export const memberships: Membership[] = [
  {
    id: 'launch-guide',
    name: 'AI App Launch Guide',
    price: 27,
    productTitle: 'AI App Launch Blueprint – Build & Launch Your First AI App in 7 Days',
    description: 'Get started with our foundational AI app development guide',
    features: [
      'Step-by-step app development blueprint',
      'Idea validation framework',
      'Launch checklist',
      '7-day implementation timeline'
    ],
    callToAction: 'Get Started',
    paymentLink: 'https://connect.intuit.com/pay/Venture24/scs-v1-29131d25b4634ea7a1eb76a845a4e17040f5fda2d27e4e60ade8da2a81182a68a9b06f1c00624d0f9de7c0c0d22044b4?locale=EN_US',
    displayOnPricing: true
  },
  {
    id: 'ai-prompts',
    name: 'AI Development Swipe File & Prompts',
    price: 19,
    productTitle: 'Full-Proof AI App Development Script & 100 AI Prompts',
    description: 'Complete AI App Development copy and paste swipe file',
    features: [
      'AI App Development script',
      '100 optimized AI prompts',
      'Design & code templates',
      'App store publishing guide'
    ],
    callToAction: 'Get Access Now',
    paymentLink: 'https://connect.intuit.com/pay/Venture24/scs-v1-d2fb5c3b8c3a4e35a585836d304c99093e40562a42ac4ed8aef31e1d785c24ceabab3e77ecf24571b3086cc3dc515af0?locale=EN_US',
    displayOnPricing: false
  },
  {
    id: 'fast-track',
    name: 'AI App Fast-Track',
    price: 97,
    productTitle: 'Build Your First AI App in a Weekend',
    description: 'A quick-start course to get your first AI-powered app up and running fast',
    features: [
      'Weekend implementation plan',
      'Fast-track development tutorials',
      'Ready-to-use templates',
      'Quick launch strategies'
    ],
    popular: true,
    callToAction: 'Start Fast-Track',
    paymentLink: 'https://connect.intuit.com/pay/Venture24/scs-v1-e50e0854ebd646ce9f2bdc011de9e2240906ffe727b44122b35e55302871dbbd8b340e17dd514dcca26afc3e31932393?locale=EN_US',
    displayOnPricing: true
  },
  {
    id: 'accelerator',
    name: 'AI App Accelerator',
    price: 297,
    productTitle: 'Monetize & Scale Your AI App Like a Pro',
    description: 'Learn how to launch, grow, and profit from your AI app with advanced automation and monetization strategies',
    features: [
      'Advanced monetization strategies',
      'Growth automation tools',
      'User acquisition frameworks',
      'App store optimization tactics',
      'Marketing automation templates'
    ],
    callToAction: 'Join Accelerator',
    paymentLink: 'https://connect.intuit.com/pay/Venture24/scs-v1-b76a64e3c7824f6cba2d03d1c07377f8351d7292d453404d92941fc5a579277520ec9b8209664d13b9caf21ed13addec?locale=EN_US',
    displayOnPricing: false
  },
  {
    id: 'business-mastery',
    name: 'AI App Business Mastery',
    price: 497,
    productTitle: 'Master AI App Development & Build a Profitable Business in 90 Days',
    description: 'A deep dive into AI-powered app development, automation, and monetization for serious entrepreneurs',
    features: [
      'Complete 90-day business plan',
      'Advanced AI integration strategies',
      'Profit maximization frameworks',
      'Scaling blueprints',
      'Expert coaching sessions',
      'Private community access'
    ],
    callToAction: 'Master AI Apps',
    paymentLink: 'https://connect.intuit.com/pay/Venture24/scs-v1-4b1f88aba51c4e7887afd01a48e75e445259744ce0c3463fa2700e961bfd1e6624fc1c65187646c0b4842f532754fde9?locale=EN_US',
    displayOnPricing: false
  },
  {
    id: 'unlimited',
    name: 'Unlimited AI App Development',
    price: 599,
    productTitle: 'Unlimited AI App Development for One Monthly Price',
    description: 'Get unlimited AI app builds, updates, and expert support—no extra fees, no limits',
    features: [
      'Unlimited app builds',
      'Ongoing updates & improvements',
      'Priority support access',
      'Monthly strategy sessions',
      'Custom feature development',
      'Publishing assistance'
    ],
    callToAction: 'Get Unlimited Access',
    paymentLink: 'https://connect.intuit.com/pay/Venture24/scs-v1-810fb25f51ee4adaa74f3c37c01811e3ed02c9b24e2a4fa3aa6672960c45341ae3e25515e44448fbb25170fc5c0562e6?locale=EN_US',
  },
  {
    id: 'elite-vip',
    name: 'AI App Elite VIP',
    price: 4999,
    productTitle: 'We Build & Launch Your AI App for You—From Idea to Market',
    description: 'A done-for-you AI app development service with custom branding, monetization, and launch strategy built in',
    features: [
      'Custom app development',
      'Professional UI/UX design',
      'Branding & identity creation',
      'Monetization strategy',
      'Launch campaign',
      'Marketing materials',
      'App store optimization',
      'VIP support',
    ],
    callToAction: 'Join Elite VIP',
    paymentLink: 'https://connect.intuit.com/pay/Venture24/scs-v1-546ab3219a574050bda67734df9112080fe4e363fb924f8b91cee95101d9f7d2920b9289cd584be5ab9708a3c900910a?locale=EN_US',
  }
];

export const bundlePaymentLinks: {[key: string]: string} = {
  // Single products (for consistency and fallback)
  'launch-guide': 'https://connect.intuit.com/pay/Venture24/scs-v1-29131d25b4634ea7a1eb76a845a4e17040f5fda2d27e4e60ade8da2a81182a68a9b06f1c00624d0f9de7c0c0d22044b4?locale=EN_US',
  'ai-prompts': 'https://connect.intuit.com/pay/Venture24/scs-v1-d2fb5c3b8c3a4e35a585836d304c99093e40562a42ac4ed8aef31e1d785c24ceabab3e77ecf24571b3086cc3dc515af0?locale=EN_US',
  'fast-track': 'https://connect.intuit.com/pay/Venture24/scs-v1-e50e0854ebd646ce9f2bdc011de9e2240906ffe727b44122b35e55302871dbbd8b340e17dd514dcca26afc3e31932393?locale=EN_US',
  'accelerator': 'https://connect.intuit.com/pay/Venture24/scs-v1-b76a64e3c7824f6cba2d03d1c07377f8351d7292d453404d92941fc5a579277520ec9b8209664d13b9caf21ed13addec?locale=EN_US',
  'business-mastery': 'https://connect.intuit.com/pay/Venture24/scs-v1-4b1f88aba51c4e7887afd01a48e75e445259744ce0c3463fa2700e961bfd1e6624fc1c65187646c0b4842f532754fde9?locale=EN_US',
  'unlimited': 'https://connect.intuit.com/pay/Venture24/scs-v1-810fb25f51ee4adaa74f3c37c01811e3ed02c9b24e2a4fa3aa6672960c45341ae3e25515e44448fbb25170fc5c0562e6?locale=EN_US',
  'elite-vip': 'https://connect.intuit.com/pay/Venture24/scs-v1-546ab3219a574050bda67734df9112080fe4e363fb924f8b91cee95101d9f7d2920b9289cd584be5ab9708a3c900910a?locale=EN_US',
  
  // Two product combinations
  'ai-prompts,launch-guide': 'https://connect.intuit.com/pay/Venture24/scs-v1-8a558772b3fb4b4eb6bfa5fa5877db8e5c3f1119cdc8461caa139deb6bdb903abf1769fe5960429c8a62b583e4e46e08?locale=EN_US',
  'launch-guide,ai-prompts': 'https://connect.intuit.com/pay/Venture24/scs-v1-8a558772b3fb4b4eb6bfa5fa5877db8e5c3f1119cdc8461caa139deb6bdb903abf1769fe5960429c8a62b583e4e46e08?locale=EN_US',
  
  'fast-track,launch-guide': 'https://connect.intuit.com/pay/Venture24/scs-v1-9e6a8bb45791494ea20d963fe87af0f938ba5dbebc0c4328840395638e90d574c4cbc933b2294278b7e8e22359bd71a8?locale=EN_US',
  'launch-guide,fast-track': 'https://connect.intuit.com/pay/Venture24/scs-v1-9e6a8bb45791494ea20d963fe87af0f938ba5dbebc0c4328840395638e90d574c4cbc933b2294278b7e8e22359bd71a8?locale=EN_US',
  
  'accelerator,launch-guide': 'https://connect.intuit.com/pay/Venture24/scs-v1-9bc3c1fda2714334969b149eb4f5a542caf85aa58e4f4be58a6486bb7b36130c74c2d215531b410bb5c3464313a0c972?locale=EN_US',
  'launch-guide,accelerator': 'https://connect.intuit.com/pay/Venture24/scs-v1-9bc3c1fda2714334969b149eb4f5a542caf85aa58e4f4be58a6486bb7b36130c74c2d215531b410bb5c3464313a0c972?locale=EN_US',
  
  'business-mastery,launch-guide': 'https://connect.intuit.com/pay/Venture24/scs-v1-f1c11ec21f134bdc803afcf89de8b1bd3eb5f1db1a724992aae558cf69ee7a0ce0f4cb9dfe294a48b8f0f7dfcd3e113e?locale=EN_US',
  'launch-guide,business-mastery': 'https://connect.intuit.com/pay/Venture24/scs-v1-f1c11ec21f134bdc803afcf89de8b1bd3eb5f1db1a724992aae558cf69ee7a0ce0f4cb9dfe294a48b8f0f7dfcd3e113e?locale=EN_US',
  
  'fast-track,accelerator': 'https://connect.intuit.com/pay/Venture24/scs-v1-911b21df169242a99e5c2a34cfcef86fcae4199eb23040cf88f9a22c1ff0bae1dadfb6af34f34b5a9f911bdeb029bc9f?locale=EN_US',
  'accelerator,fast-track': 'https://connect.intuit.com/pay/Venture24/scs-v1-911b21df169242a99e5c2a34cfcef86fcae4199eb23040cf88f9a22c1ff0bae1dadfb6af34f34b5a9f911bdeb029bc9f?locale=EN_US',
  
  'fast-track,business-mastery': 'https://connect.intuit.com/pay/Venture24/scs-v1-302d9d6c3c204c9bbc4f9c9077647bd3c1aa839499c44c9ea4ea90eb4d0ce78a9722fb241e0a4f199a7c2d02018e2ac9?locale=EN_US',
  'business-mastery,fast-track': 'https://connect.intuit.com/pay/Venture24/scs-v1-302d9d6c3c204c9bbc4f9c9077647bd3c1aa839499c44c9ea4ea90eb4d0ce78a9722fb241e0a4f199a7c2d02018e2ac9?locale=EN_US',
  
  'accelerator,business-mastery': 'https://connect.intuit.com/pay/Venture24/scs-v1-82ad24bc9f2e4d3dbc8cd2cca97dba5380f6063de21b4a308041de58a686439bbdfaba2e4a654cf4bed088b61d9cf58f?locale=EN_US',
  'business-mastery,accelerator': 'https://connect.intuit.com/pay/Venture24/scs-v1-82ad24bc9f2e4d3dbc8cd2cca97dba5380f6063de21b4a308041de58a686439bbdfaba2e4a654cf4bed088b61d9cf58f?locale=EN_US',
  
  // Three product combinations
  'ai-prompts,fast-track,launch-guide': 'https://connect.intuit.com/pay/Venture24/scs-v1-20a9605278704e718a4bedea2c9fb29d0e6c71a378254a3f83b909c78c5bc6eb5a1d9bd74b9e4e7aaaca5cb9883c9cf0?locale=EN_US',
  'fast-track,ai-prompts,launch-guide': 'https://connect.intuit.com/pay/Venture24/scs-v1-20a9605278704e718a4bedea2c9fb29d0e6c71a378254a3f83b909c78c5bc6eb5a1d9bd74b9e4e7aaaca5cb9883c9cf0?locale=EN_US',
  'launch-guide,ai-prompts,fast-track': 'https://connect.intuit.com/pay/Venture24/scs-v1-20a9605278704e718a4bedea2c9fb29d0e6c71a378254a3f83b909c78c5bc6eb5a1d9bd74b9e4e7aaaca5cb9883c9cf0?locale=EN_US',
  
  'accelerator,ai-prompts,launch-guide': 'https://connect.intuit.com/pay/Venture24/scs-v1-25c771059603408584ec30763bf16b56247af72ab8834839bb9be771de463e9deed1b8e2ab8f401b924240552b78f32e?locale=EN_US',
  'ai-prompts,accelerator,launch-guide': 'https://connect.intuit.com/pay/Venture24/scs-v1-25c771059603408584ec30763bf16b56247af72ab8834839bb9be771de463e9deed1b8e2ab8f401b924240552b78f32e?locale=EN_US',
  'launch-guide,ai-prompts,accelerator': 'https://connect.intuit.com/pay/Venture24/scs-v1-25c771059603408584ec30763bf16b56247af72ab8834839bb9be771de463e9deed1b8e2ab8f401b924240552b78f32e?locale=EN_US',
  
  'ai-prompts,business-mastery,launch-guide': 'https://connect.intuit.com/pay/Venture24/scs-v1-60cc4a54f56c40c68459de718e1d37176e1c7799deae4248a85b2db33fa948d942989813c4da48b59a2f24c28c4275c0?locale=EN_US',
  'business-mastery,ai-prompts,launch-guide': 'https://connect.intuit.com/pay/Venture24/scs-v1-60cc4a54f56c40c68459de718e1d37176e1c7799deae4248a85b2db33fa948d942989813c4da48b59a2f24c28c4275c0?locale=EN_US',
  'launch-guide,ai-prompts,business-mastery': 'https://connect.intuit.com/pay/Venture24/scs-v1-60cc4a54f56c40c68459de718e1d37176e1c7799deae4248a85b2db33fa948d942989813c4da48b59a2f24c28c4275c0?locale=EN_US',
  
  'accelerator,fast-track,launch-guide': 'https://connect.intuit.com/pay/Venture24/scs-v1-be27dc68c0ee43e6bd993ba6e4f815ff1d5a20cede8249bb9fe6763305070a00d2858e0500724dd19d8aba60a395cda8?locale=EN_US',
  'fast-track,accelerator,launch-guide': 'https://connect.intuit.com/pay/Venture24/scs-v1-be27dc68c0ee43e6bd993ba6e4f815ff1d5a20cede8249bb9fe6763305070a00d2858e0500724dd19d8aba60a395cda8?locale=EN_US',
  'launch-guide,fast-track,accelerator': 'https://connect.intuit.com/pay/Venture24/scs-v1-be27dc68c0ee43e6bd993ba6e4f815ff1d5a20cede8249bb9fe6763305070a00d2858e0500724dd19d8aba60a395cda8?locale=EN_US',
  
  'business-mastery,fast-track,launch-guide': 'https://connect.intuit.com/pay/Venture24/scs-v1-90990f8090f84a4097c1da8df1caf8f3542fa0da098b412cb6aac393a2c3d2cc5d0bd3f677a74709be79993fa45c299f?locale=EN_US',
  'fast-track,business-mastery,launch-guide': 'https://connect.intuit.com/pay/Venture24/scs-v1-90990f8090f84a4097c1da8df1caf8f3542fa0da098b412cb6aac393a2c3d2cc5d0bd3f677a74709be79993fa45c299f?locale=EN_US',
  'launch-guide,fast-track,business-mastery': 'https://connect.intuit.com/pay/Venture24/scs-v1-90990f8090f84a4097c1da8df1caf8f3542fa0da098b412cb6aac393a2c3d2cc5d0bd3f677a74709be79993fa45c299f?locale=EN_US',
  
  'accelerator,business-mastery,launch-guide': 'https://connect.intuit.com/pay/Venture24/scs-v1-6f5b310c927c4adda9ba65c06db6211cffe90cd363354984b075338caf1c0b74b615383fbd014ed68f8e5c816e7e2e08?locale=EN_US',
  'business-mastery,accelerator,launch-guide': 'https://connect.intuit.com/pay/Venture24/scs-v1-6f5b310c927c4adda9ba65c06db6211cffe90cd363354984b075338caf1c0b74b615383fbd014ed68f8e5c816e7e2e08?locale=EN_US',
  'launch-guide,accelerator,business-mastery': 'https://connect.intuit.com/pay/Venture24/scs-v1-6f5b310c927c4adda9ba65c06db6211cffe90cd363354984b075338caf1c0b74b615383fbd014ed68f8e5c816e7e2e08?locale=EN_US',
  
  // Premium products combination (the 3 main offers)
  'fast-track,accelerator,business-mastery': 'https://connect.intuit.com/pay/Venture24/scs-v1-810fb25f51ee4adaa74f3c37c01811e3ed02c9b24e2a4fa3aa6672960c45341ae3e25515e44448fbb25170fc5c0562e6?locale=EN_US',
  'accelerator,business-mastery,fast-track': 'https://connect.intuit.com/pay/Venture24/scs-v1-810fb25f51ee4adaa74f3c37c01811e3ed02c9b24e2a4fa3aa6672960c45341ae3e25515e44448fbb25170fc5c0562e6?locale=EN_US',
  'business-mastery,fast-track,accelerator': 'https://connect.intuit.com/pay/Venture24/scs-v1-810fb25f51ee4adaa74f3c37c01811e3ed02c9b24e2a4fa3aa6672960c45341ae3e25515e44448fbb25170fc5c0562e6?locale=EN_US',
  
  // Four product combinations
  'accelerator,ai-prompts,fast-track,launch-guide': 'https://connect.intuit.com/pay/Venture24/scs-v1-1d9de48f32e4464d858e56a1ee784d6edc81e641d2e34ad1812f6a8f824c2df125921a1c22d34882b311b67656bf00ce?locale=EN_US',
  'ai-prompts,accelerator,fast-track,launch-guide': 'https://connect.intuit.com/pay/Venture24/scs-v1-1d9de48f32e4464d858e56a1ee784d6edc81e641d2e34ad1812f6a8f824c2df125921a1c22d34882b311b67656bf00ce?locale=EN_US',
  'fast-track,accelerator,ai-prompts,launch-guide': 'https://connect.intuit.com/pay/Venture24/scs-v1-1d9de48f32e4464d858e56a1ee784d6edc81e641d2e34ad1812f6a8f824c2df125921a1c22d34882b311b67656bf00ce?locale=EN_US',
  'launch-guide,accelerator,ai-prompts,fast-track': 'https://connect.intuit.com/pay/Venture24/scs-v1-1d9de48f32e4464d858e56a1ee784d6edc81e641d2e34ad1812f6a8f824c2df125921a1c22d34882b311b67656bf00ce?locale=EN_US',
  
  'accelerator,ai-prompts,business-mastery,launch-guide': 'https://connect.intuit.com/pay/Venture24/scs-v1-457bb02f1f7a4ca0b901539d3aa4ed6c6569fb1c013a416394ae9c13990a1c9a87ef4ab9069a43188d582f0090d0b587?locale=EN_US',
  'ai-prompts,accelerator,business-mastery,launch-guide': 'https://connect.intuit.com/pay/Venture24/scs-v1-457bb02f1f7a4ca0b901539d3aa4ed6c6569fb1c013a416394ae9c13990a1c9a87ef4ab9069a43188d582f0090d0b587?locale=EN_US',
  'business-mastery,accelerator,ai-prompts,launch-guide': 'https://connect.intuit.com/pay/Venture24/scs-v1-457bb02f1f7a4ca0b901539d3aa4ed6c6569fb1c013a416394ae9c13990a1c9a87ef4ab9069a43188d582f0090d0b587?locale=EN_US',
  'launch-guide,accelerator,ai-prompts,business-mastery': 'https://connect.intuit.com/pay/Venture24/scs-v1-457bb02f1f7a4ca0b901539d3aa4ed6c6569fb1c013a416394ae9c13990a1c9a87ef4ab9069a43188d582f0090d0b587?locale=EN_US',
  
  'ai-prompts,business-mastery,fast-track,launch-guide': 'https://connect.intuit.com/pay/Venture24/scs-v1-1a5517f75b6647c7899cf5582f3b689380af9895ae81405fabc870348a79c95fdc4a6d304a964c528ec215a4749fa101?locale=EN_US',
  'business-mastery,ai-prompts,fast-track,launch-guide': 'https://connect.intuit.com/pay/Venture24/scs-v1-1a5517f75b6647c7899cf5582f3b689380af9895ae81405fabc870348a79c95fdc4a6d304a964c528ec215a4749fa101?locale=EN_US',
  'fast-track,ai-prompts,business-mastery,launch-guide': 'https://connect.intuit.com/pay/Venture24/scs-v1-1a5517f75b6647c7899cf5582f3b689380af9895ae81405fabc870348a79c95fdc4a6d304a964c528ec215a4749fa101?locale=EN_US',
  'launch-guide,ai-prompts,business-mastery,fast-track': 'https://connect.intuit.com/pay/Venture24/scs-v1-1a5517f75b6647c7899cf5582f3b689380af9895ae81405fabc870348a79c95fdc4a6d304a964c528ec215a4749fa101?locale=EN_US',
  
  // Special 4-product combo with launch-guide + all 3 premium products
  'launch-guide,fast-track,accelerator,business-mastery': 'https://connect.intuit.com/pay/Venture24/scs-v1-9eb59ee5c26c49639a7c2a989fbd6499d8cebb204c48414da67fd9470f4f667e0fbfdcd72fa04c849ff941ab3587a37e?locale=EN_US',
  'fast-track,accelerator,business-mastery,launch-guide': 'https://connect.intuit.com/pay/Venture24/scs-v1-9eb59ee5c26c49639a7c2a989fbd6499d8cebb204c48414da67fd9470f4f667e0fbfdcd72fa04c849ff941ab3587a37e?locale=EN_US',
  'accelerator,business-mastery,fast-track,launch-guide': 'https://connect.intuit.com/pay/Venture24/scs-v1-9eb59ee5c26c49639a7c2a989fbd6499d8cebb204c48414da67fd9470f4f667e0fbfdcd72fa04c849ff941ab3587a37e?locale=EN_US',
  'business-mastery,fast-track,accelerator,launch-guide': 'https://connect.intuit.com/pay/Venture24/scs-v1-9eb59ee5c26c49639a7c2a989fbd6499d8cebb204c48414da67fd9470f4f667e0fbfdcd72fa04c849ff941ab3587a37e?locale=EN_US',
  
  // Five product combinations
  'ai-prompts,business-mastery,fast-track,launch-guide,accelerator': 'https://connect.intuit.com/pay/Venture24/scs-v1-9d1e40f7f6a0447e8144cfd5ba5aa5daacca7b6fa3a64ee3b8bd59db1215ecf278a061eb49e740b194f5263e4a668d80?locale=EN_US',
  'accelerator,ai-prompts,business-mastery,fast-track,launch-guide': 'https://connect.intuit.com/pay/Venture24/scs-v1-9d1e40f7f6a0447e8144cfd5ba5aa5daacca7b6fa3a64ee3b8bd59db1215ecf278a061eb49e740b194f5263e4a668d80?locale=EN_US',
};

export const getMembership = (id: string): Membership | undefined => {
  return memberships.find(membership => membership.id === id);
};

export const getBundlePaymentLink = (ids: string[]): string | undefined => {
  // Make sure we're working with unique IDs, sorted alphabetically
  const sortedIds = [...new Set(ids)].sort();
  const key = sortedIds.join(',');
  
  console.log("Looking up bundle payment link for products:", sortedIds);
  console.log("Bundle key:", key);
  
  // First check: Direct lookup in the dictionary for exact matches
  if (bundlePaymentLinks[key]) {
    console.log("Found exact payment link match in dictionary");
    return bundlePaymentLinks[key];
  }
  
  // Debug information for troubleshooting
  console.log("Products in cart:", sortedIds);
  console.log("Cart includes business-mastery:", sortedIds.includes('business-mastery'));
  
  // Special handling for specific combinations with business-mastery ($497 product)
  if (sortedIds.includes('business-mastery')) {
    console.log("Business-mastery ($497) is in the cart - special handling");
    
    // Handle ALL 5 products combo
    if (sortedIds.includes('ai-prompts') && 
        sortedIds.includes('launch-guide') && 
        sortedIds.includes('fast-track') && 
        sortedIds.includes('accelerator') && 
        sortedIds.includes('business-mastery')) {
      console.log("All five products bundle ($937)");
      return 'https://connect.intuit.com/pay/Venture24/scs-v1-9d1e40f7f6a0447e8144cfd5ba5aa5daacca7b6fa3a64ee3b8bd59db1215ecf278a061eb49e740b194f5263e4a668d80?locale=EN_US';
    }
    
    // Handle premium product combinations with business-mastery
    if (sortedIds.includes('fast-track') && sortedIds.includes('accelerator')) {
      console.log("Three premium products combo detected");
      // With launch guide?
      if (sortedIds.includes('launch-guide')) {
        console.log("Premium combo + launch guide");
        return 'https://connect.intuit.com/pay/Venture24/scs-v1-9eb59ee5c26c49639a7c2a989fbd6499d8cebb204c48414da67fd9470f4f667e0fbfdcd72fa04c849ff941ab3587a37e?locale=EN_US';
      }
      console.log("Just the premium combo (no launch guide)");
      return 'https://connect.intuit.com/pay/Venture24/scs-v1-810fb25f51ee4adaa74f3c37c01811e3ed02c9b24e2a4fa3aa6672960c45341ae3e25515e44448fbb25170fc5c0562e6?locale=EN_US';
    }
    
    // Business-mastery + launch-guide
    if (sortedIds.includes('launch-guide') && sortedIds.length === 2) {
      console.log("Business-mastery + launch-guide combo");
      return 'https://connect.intuit.com/pay/Venture24/scs-v1-f1c11ec21f134bdc803afcf89de8b1bd3eb5f1db1a724992aae558cf69ee7a0ce0f4cb9dfe294a48b8f0f7dfcd3e113e?locale=EN_US';
    }
    
    // Business-mastery + fast-track
    if (sortedIds.includes('fast-track')) {
      console.log("Business-mastery + fast-track combo");
      return 'https://connect.intuit.com/pay/Venture24/scs-v1-302d9d6c3c204c9bbc4f9c9077647bd3c1aa839499c44c9ea4ea90eb4d0ce78a9722fb241e0a4f199a7c2d02018e2ac9?locale=EN_US';
    }
    
    // Business-mastery + accelerator
    if (sortedIds.includes('accelerator')) {
      console.log("Business-mastery + accelerator combo");
      return 'https://connect.intuit.com/pay/Venture24/scs-v1-82ad24bc9f2e4d3dbc8cd2cca97dba5380f6063de21b4a308041de58a686439bbdfaba2e4a654cf4bed088b61d9cf58f?locale=EN_US';
    }
    
    // If no specific combination is found, but business-mastery is in cart,
    // return the business-mastery link as fallback
    console.log("Falling back to business-mastery link");
    return 'https://connect.intuit.com/pay/Venture24/scs-v1-4b1f88aba51c4e7887afd01a48e75e445259744ce0c3463fa2700e961bfd1e6624fc1c65187646c0b4842f532754fde9?locale=EN_US';
  }
  
  // Handle all three premium products
  const hasAllThreePremium = (
    sortedIds.includes('fast-track') && 
    sortedIds.includes('accelerator') && 
    sortedIds.includes('business-mastery')
  );
  
  // Specific combinations handling based on unique patterns
  if (hasAllThreePremium) {
    // Check for all three premium products plus other items
    if (sortedIds.includes('launch-guide')) {
      if (sortedIds.includes('ai-prompts')) {
        // All premium products + launch guide + order bump (ai-prompts)
        console.log("Found all premium products + launch guide + order bump");
        return 'https://connect.intuit.com/pay/Venture24/scs-v1-9d1e40f7f6a0447e8144cfd5ba5aa5daacca7b6fa3a64ee3b8bd59db1215ecf278a061eb49e740b194f5263e4a668d80?locale=EN_US';
      } else {
        // All premium products + launch guide
        console.log("Found all premium products + launch guide");
        return 'https://connect.intuit.com/pay/Venture24/scs-v1-9eb59ee5c26c49639a7c2a989fbd6499d8cebb204c48414da67fd9470f4f667e0fbfdcd72fa04c849ff941ab3587a37e?locale=EN_US';
      }
    } else {
      // Just the premium products bundle (no launch guide)
      console.log("Found premium products bundle (no launch guide)");
      return 'https://connect.intuit.com/pay/Venture24/scs-v1-810fb25f51ee4adaa74f3c37c01811e3ed02c9b24e2a4fa3aa6672960c45341ae3e25515e44448fbb25170fc5c0562e6?locale=EN_US';
    }
  }
  
  // Handle two-product premium combinations specifically
  if (sortedIds.length === 2) {
    if (sortedIds.includes('fast-track') && sortedIds.includes('accelerator')) {
      console.log("Found fast-track + accelerator combo ($394)");
      return 'https://connect.intuit.com/pay/Venture24/scs-v1-911b21df169242a99e5c2a34cfcef86fcae4199eb23040cf88f9a22c1ff0bae1dadfb6af34f34b5a9f911bdeb029bc9f?locale=EN_US';
    } else if (sortedIds.includes('fast-track') && sortedIds.includes('business-mastery')) {
      console.log("Found fast-track + business-mastery combo ($594)");
      return 'https://connect.intuit.com/pay/Venture24/scs-v1-302d9d6c3c204c9bbc4f9c9077647bd3c1aa839499c44c9ea4ea90eb4d0ce78a9722fb241e0a4f199a7c2d02018e2ac9?locale=EN_US';
    } else if (sortedIds.includes('accelerator') && sortedIds.includes('business-mastery')) {
      console.log("Found accelerator + business-mastery combo ($794)");
      return 'https://connect.intuit.com/pay/Venture24/scs-v1-82ad24bc9f2e4d3dbc8cd2cca97dba5380f6063de21b4a308041de58a686439bbdfaba2e4a654cf4bed088b61d9cf58f?locale=EN_US';
    }
  }
  
  // Fallback to single product if there's just one
  if (sortedIds.length === 1) {
    const singleProduct = getMembership(sortedIds[0]);
    if (singleProduct && singleProduct.paymentLink) {
      console.log("Falling back to single product payment link");
      return singleProduct.paymentLink;
    }
  }
  
  console.log("No matching payment link found");
  return undefined;
};
